import { Colors } from "react-native-ui-lib";
import { Badge as BaseBadge } from "react-native-ui-lib/src/components/badge";
import { BadgeProps } from "@towersystems/roam-common-native";

export interface StatusBadgeProps extends Omit<BadgeProps, "status"> {
  status: "PENDING" | "COMPLETED";
}

export const StatusBadge = ({ status, children, style }: StatusBadgeProps) => {
  function getStyle(status: StatusBadgeProps["status"]) {
    switch (status) {
      case "PENDING":
        return { backgroundColor: Colors.statusOpen };
      case "COMPLETED":
        return { backgroundColor: Colors.statusClosed };
    }
  }

  const statusStyle = getStyle(status);

  return (
    <BaseBadge
      labelStyle={{ color: Colors.black }}
      {...statusStyle}
      style={style}
      label={children}
    ></BaseBadge>
  );
};
